module.exports = __webpack_public_path__ + "static/media/google-logo.1cdc8fce.svg";